import { HttpHeaders, HttpParams } from '@angular/common/http';
import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { newFeatures } from 'src/app/model/page/newly-added-features';
import { SandboxPage } from 'src/app/model/page/sandbox-page';
import { CancelGetRefundCancelRQ } from 'src/app/model/request/cancel-get-refund-order-cancel-screen-request';
import { AirlineOffersScreen } from 'src/app/model/screen/airline-offers-screen';
import { CancelBookingGetRefundScreen } from 'src/app/model/screen/cancel-booking-get-refund';
import { DisruptedOrderViewerScreen, RequestBody } from 'src/app/model/screen/disrupted-order-viewer-screen';
import { OfferPriceScreen } from 'src/app/model/screen/offer-price-screen';
import { YourBookingScreen } from 'src/app/model/screen/your-booking-screen';
import { SandboxMaintenanceAlert } from 'src/app/model/shared/sandbox-maintenance-alert-banner';
import { ApiService, Response } from 'src/app/service/api.service';
import { CommonService } from 'src/app/service/common.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { IndexdbConfigService } from 'src/app/service/indexdb-config.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import findOrderJSON from 'src/assets/json/find-order/request/find-order-default-params.json';
import ocnCancelJSON from 'src/assets/json/ocn-cancel-and-reaccomodation/ocn-cancel-request-default-params.json';
import reQuoteOrderJSON from 'src/assets/json/order-reshop/requote/request/requote-request-default-params.json';
import htmlTitle from 'src/assets/json/redirects/html-title.json';
import { config } from 'src/environments/environment';

import { documentToHtmlString } from '../../../../model/shared/index-featureGuide';

declare function featureGuide(): any;
declare function featureGuidejs(): any;
@Component({
  selector: 'app-sandbox-page',
  templateUrl: './sandbox-page.component.html',
  styleUrls: ['./sandbox-page.component.scss']
})
export class SandboxPageComponent implements OnInit, AfterViewChecked, OnDestroy {
  activeSideMenu: any;
  hideSideMenu: any;
  activeMainMenu: any;
  disableOfferFilter: any;
  showSuccess: any;
  successMessage: any;
  showError: any;
  errorMessage: any;
  showWarning: any;
  warningMessage: any;
  widthAdjust: any;
  yourBookingScreenDiv: boolean = false;

  sandboxPage: SandboxPage = {} as SandboxPage;
  newFeatures: newFeatures = {} as newFeatures;

  disaplyAddAancilliariesShowScreen: boolean = false;
  addBaggages: boolean = false;
  addMeal: boolean = false;
  addSeats: boolean = false;
  cancelGetRefundCancelRQ: CancelGetRefundCancelRQ = {} as CancelGetRefundCancelRQ;
  cancelBookingGetRefundScreen: CancelBookingGetRefundScreen = {} as CancelBookingGetRefundScreen;
  apiResponse: Response = {} as Response;
  disruptedOrderViewScreenDate: DisruptedOrderViewerScreen = {} as DisruptedOrderViewerScreen;
  distruptedPnrCount: any;
  aggrId = '';
  iataNum = '';
  sandboxScreenDataSourceSubscription: any;
  APIConnectionParamsMap = new Map();
  isUserVisitingSandBoxFirstTime: boolean = false;
  SandboxMaintenanceLabels: SandboxMaintenanceAlert = {} as SandboxMaintenanceAlert;
  constructor(
    private indexdbConfigService: IndexdbConfigService,
    private contentfulService: ContentfulService,
    private sandboxPageStateService: SandboxPageStateService,
    private localAssetReaderService: LocalAssetReaderService,
    private apiService: ApiService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private commonService: CommonService
  ) {
    Object.entries(findOrderJSON).forEach((entry) => {
      const [key, value] = entry;
      this.inputParamsMap.set(key, value);
    });
    Object.entries(reQuoteOrderJSON).forEach((entry) => {
      const [key, value] = entry;
      this.reQuoteInputParamsMap.set(key, value);
    });
    Object.entries(ocnCancelJSON).forEach((entry) => {
      const [key, value] = entry;
      this.APIConnectionParamsMap.set(key, value);
    });
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      // return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }

  inputParamsMap = new Map();
  reQuoteInputParamsMap = new Map();

  requstBody: any[] = [];

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'sandbox') {
        this.sandboxPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'Sandbox' };
    this.contentfulService.getPageContentResponse(query).then((loginPageResponse) => {
      this.newFeatures.newfeatureSectionCard = [];
      this.newFeatures.sections = [];
      this.mapBanner(loginPageResponse.includes.Entry);
      this.mapHtmlTitle(loginPageResponse.items);
      this.mapCards(loginPageResponse.includes.Entry);
      if (config.sandboxFeatureGuide && this.isUserVisitingSandBoxFirstTime) {
        featureGuide();
        featureGuidejs();
      }
    });
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      this.mapLables(labelItems[0]?.fields.constants);
    });

    // this.getOcnMessages();
    this.sandboxScreenDataSourceSubscription = this.sandboxPageStateService.sandboxScreenDataSource.subscribe((res: any) => {
      this.activeSideMenu = res.sandboxMenu.sideMenu;
      this.hideSideMenu = res.sandboxMenu.hideSideMenu;
      this.activeMainMenu = res.sandboxMenu.mainMenu;
      this.disableOfferFilter = res.sandboxMenu.disableOfferFilter;
      this.showError = res.sandboxMenu.showError;
      this.errorMessage = res.sandboxMenu.errorMessage;
      if (this.showError === 'Yes') {
        setTimeout(() => {
          let patchSandboxSourceData = { showError: 'No' };
          this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
        }, 6000);
      }
      this.showWarning = res.sandboxMenu.showWarning;
      this.warningMessage = res.sandboxMenu.warningMessage;
      this.widthAdjust = res.sandboxMenu.widthMainMenu;
      this.showSuccess = res.sandboxMenu.showSuccess;
      this.successMessage = res.sandboxMenu.successMessage;
      this.distruptedPnrCount = res.sandboxMenu.distruptedPnrCount;
    });
    this.indexdbConfigService.createIndexDB().then((result: any) => {
      this.sandboxPageStateService.updateIndexDBConfig(result);
    });
    this.isUserVisitingSandBoxFirstTime = this.commonService['checkForUsersFirstVisit']('addOfferFeature');
  }

  mapLables(labels: SandboxMaintenanceAlert) {
    this.SandboxMaintenanceLabels = {
      SandboxMaintenanceAlert: labels.SandboxMaintenanceAlert,
      mainHeading: labels.mainHeading,
      SandboxMessages: labels.SandboxMessages
    };
  }

  private featureGuideCard(entry: Entry<any>) {
    let headerImage: any = entry.fields['headImage'];
    this.newFeatures.newfeatureSectionCard.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      headImage: headerImage?.fields?.file?.url,
      richTextBody: entry.fields['body'] as string
    });
    this.newFeatures.newfeatureSectionCard.sort((a, b) => a.order - b.order);
  }

  private mapCards(newFeatursContentPageEntries: Entry<any>[]) {
    newFeatursContentPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        this.featureGuideCard(entry);
      });
  }

  async getOcnMessages() {
    const apiConnectionProfile = this.sandboxPageStateService.getActiveAPIConnectionProfile();

    let aggregatorId: any = apiConnectionProfile.aggregatorID;
    let iataNum: any = apiConnectionProfile.iata;
    let queryParams = new HttpParams();
    queryParams = queryParams.append('aggregator_id', aggregatorId);
    queryParams = queryParams.append('iata_number', iataNum);
    queryParams = queryParams.append('status', 'PENDING');
    this.apiResponse = await this.apiService.sendGetRequest('/read-ocn-messages', queryParams);
    if (this.apiResponse.success) {
      let distruptedPnrCount: any = 0;
      if (typeof distruptedPnrCount === 'undefined') {
        distruptedPnrCount = 0;
      } else {
        let ocnMessageData: any = this.apiResponse.success;
        ocnMessageData.forEach((ocnMessageDetail: any, i: number) => {
          if (ocnMessageDetail.status === 'PENDING') {
            distruptedPnrCount++;
          }
        });
      }
      this.sandboxPageStateService.updateDistruptedPnrCount(distruptedPnrCount);
    }
  }

  updateGuideVisit(featureName: string) {
    localStorage.setItem(featureName, this.sandboxPageStateService.getEncodedUserId() + featureName);
  }
  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.sandboxPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }

  tabChange(menuName: 'findOrder' | 'searchOffer' | 'filterOffer' | 'ocnNotification' | 'orderDetails' | 'log' | 'settings' | 'hide', displaySideMenu: 'Yes' | 'No' | null = null) {
    let patchSandboxSourceData = {
      hideSideMenu: 'No',
      sideMenu: menuName
    };
    if (displaySideMenu != null) {
      patchSandboxSourceData.hideSideMenu = displaySideMenu;
    }
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  disruptScreen() {
    let patchSandboxSourceData = { mainMenu: 'disrupted-offers', sideMenu: 'none' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  async displayCancelError() {
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.CANCEL_HOLD_BOOKING_REQUEST_TEMPLATE);
    this.cancelGetRefundCancelRQ = JSON.parse(jsonRequestTemplate as any);
    let cancelBookingGetRefundDetail: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = cancelBookingGetRefundDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let owner = cancelBookingGetRefundDetail.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERVIEWRS[0].RESPONSE[0].ORDER[0].$.OWNER;
    this.cancelGetRefundCancelRQ['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.cancelGetRefundCancelRQ['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.cancelGetRefundCancelRQ['S:Envelope']['SOAP-ENV:Header'] = '';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.$.Version = '17.2';
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.Query.Order.$.OrderID = pnr;
    this.cancelGetRefundCancelRQ['S:Envelope']['S:Body']!.OrderCancelRQ.Query.Order.$.Owner = owner;
    await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CANCEL_SCREEN_URL, JSON.stringify(this.cancelGetRefundCancelRQ), this.reQuoteInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderCancel17_2_V1'
      }),
      responseType: 'text'
    });
    this.confirmCancelHeldBookingMapping(this.sandboxPageStateService.ORDER_CANCEL_SCREEN_URL);
  }

  confirmCancelHeldBookingMapping(url: string) {
    let CancelBookingGetRefundXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let reQuoteCancelBookingGetRefundJSONData = this.xmlToJsonParserService.parseXMLToJSON(CancelBookingGetRefundXMLData);
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      patchSandboxSourceData = { mainMenu: 'none', showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.booking.bookingStatus = 'CANCELLED';
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
      let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
      findOrderScreenData.isYourBookingStatus = 'CANCELLED';
      this.sandboxPageStateService.updateFindOrderScreen(findOrderScreenData);
      setTimeout(() => {
        let patchSandboxSourceData = { mainMenu: 'your-booking-screen', sideMenu: 'findOrder' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 100);
    }
  }
  closeAlert() {
    this.SandboxMaintenanceLabels.SandboxMaintenanceAlert = false;
  }
  removeErrorSection() {
    let patchSandboxSourceData = { showError: 'No' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  removeWarningSection() {
    let patchSandboxSourceData = { showWarning: 'No' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  removeSuccessSection() {
    let patchSandboxSourceData = { showSuccess: 'No' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  hasAirlineOffersScreenData() {
    const airlineOffersScreen: AirlineOffersScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    return airlineOffersScreen.xml && airlineOffersScreen.xml !== '';
  }

  hasOfferPriceScreenData() {
    const offerPriceScreen: OfferPriceScreen = this.sandboxPageStateService.getOfferPriceScreenData();
    return offerPriceScreen.xml && offerPriceScreen.xml !== '';
  }

  hasYourBookingScreenData() {
    const yourBookingScreen: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    return yourBookingScreen.xml && yourBookingScreen.xml !== '';
  }

  async disruptPNR() {
    let jsonRequestTemplate: any = await this.localAssetReaderService.getContent(this.sandboxPageStateService.OCN_CANCEL_AND_REACCOMODATION_REQUEST_TEMPLATE);

    let yourBookingScreenResponse = this.sandboxPageStateService.getYourBookingScreenData();
    let pnr = yourBookingScreenResponse.booking.pnrNumber;

    this.APIConnectionParamsMap.set('##EmailContact##Address##', this.sandboxPageStateService.getActiveAPIConnectionProfile().contactEMail);
    this.APIConnectionParamsMap.set('##IATA_Number##', this.sandboxPageStateService.getActiveAPIConnectionProfile().iata);
    this.APIConnectionParamsMap.set('##AgencyID##', this.sandboxPageStateService.getActiveAPIConnectionProfile().agencyName);
    this.APIConnectionParamsMap.set('##AggregatorParticipant##Name##', this.sandboxPageStateService.getActiveAPIConnectionProfile().aggregatorName);
    this.APIConnectionParamsMap.set('##AggregatorParticipant##AggregatorID##', this.sandboxPageStateService.getActiveAPIConnectionProfile().aggregatorID);

    await this.apiService.getJSONResponse(
      this.sandboxPageStateService.OCN_CANCEL_AND_REACCOMODATION_SEVICE_URL.replace('PNR', pnr),
      jsonRequestTemplate,
      this.APIConnectionParamsMap,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'text'
      },
      'orders' + pnr + 'disruptbookings#DisruptBooking'
    );

    const result: any = this.sandboxPageStateService.getResponseFromMap(this.sandboxPageStateService.OCN_CANCEL_AND_REACCOMODATION_SEVICE_URL.replace('PNR', pnr));

    if (result && JSON.parse(result).error) {
      let errorMessage = JSON.parse(result).error[0].errorText;
      this.sandboxPageStateService.setErrorMessage(errorMessage);
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: errorMessage };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  public addAncilliariesShowScreen(event: any) {
    this.disaplyAddAancilliariesShowScreen = true;
    this.yourBookingScreenDiv = false;
    this.addBaggages = false;
    this.addMeal = false;
    this.addSeats = false;
  }

  public displayYourBookingPage(event: any) {
    this.disaplyAddAancilliariesShowScreen = false;
    this.addBaggages = false;
    this.addMeal = false;
    this.addSeats = false;
    this.yourBookingScreenDiv = false;
    if (event === 0) {
      this.yourBookingScreenDiv = true;
    }
    if (event === 1) {
      this.addBaggages = true;
    }
    if (event === 2) {
      this.addMeal = true;
    }
    if (event === 3) {
      this.addSeats = true;
    }
  }

  id = 'SearchFlightsScreen';

  private mapBanner(loginPageEntries: Entry<any>[]) {
    loginPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.sandboxPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  ngOnDestroy() {
    this.sandboxScreenDataSourceSubscription.unsubscribe();
  }

  async moveToArchive() {
    let isRefresh: boolean;
    let requstBody: any[];
    requstBody = this.sandboxPageStateService.getDisruptedOrderViewerScreenData().RequestBody;

    this.apiResponse = await this.apiService.sendPostRequest(requstBody, '/update-ocn-messages');

    if (this.apiResponse.error.status === 200) {
      isRefresh = true;
      this.sandboxPageStateService.updateisResfresh(isRefresh);
    }
  }
}
